import React from 'react'
import useAssistant from '../../common/hooks/useAssistant'

export default function InitChatLink({ href, children }: { href: string; children: React.ReactNode }) {
  const assistant = useAssistant()

  const newChat = '#new_chat' === href

  return (
    <a
      href={href}
      onClick={event => {
        event.preventDefault()
        event.stopPropagation()
        //
        assistant.init(newChat).catch(error => {
          // eslint-disable-next-line no-console
          console.error('Failed to initialize assistant:', assistant.id, error)
        })
      }}
    >
      {children}
    </a>
  )
}
